import { get_feed_state } from '../utils/FeedInterface';
import FeedStruct from '../utils/FeedStruct';
import {
  get_euro_value,
  get_time_passed }   from '../utils/utils';




/* WORKING: get feed data for price evaluation.
 * restructure response array for useful feed data.
 */
export default function FeedRefresh ( delay ) {

  const currentFeed = FeedStruct({});
  let override = true;

  return new Promise( ( resolve, reject ) => {
    // has stored feed data.
    if ( currentFeed.XAU_updated != null ) {
      // Check time passed.
      if ( override ) {
        // Update if everything checks...
        console.log('no update, updating feed');
        get_feed().then( re => {
          console.log( re );
          resolve( re );
        }).catch( err => {
          reject( err );
        });
      } else {
        reject( 'too soon to update feed...' );
      }
    // no feed data stored... fetch data from server.
    } else {
      // Update if everithin checks...
      get_feed().then( re => {
        console.log( re );
        resolve( re );
      }).catch( err => {
        reject( err );
      });
    }
  });

  function get_feed () {
    return new Promise(( resolve, reject ) => {
      get_feed_state( ).then( re => {

        let usefulFeed = {};
        let change = 1.0;

        // store usd - eur val before caluculating prices
        // sdb can return mixed order data.
        // so a loop in needed to find the correct object
        re.forEach( F => {
          switch( F.name ) {
            case 'USD-EUR':
              change = parseFloat( F.val );
              break;
          }
        });

        // build usefulFeed object.
        re.forEach( F =>  {
          switch( F.name ) {
            case 'FEED_UPDATE':
              // usefulFeed.tick_delay = parseFloat( F.val );
              usefulFeed.tick_delay = delay;
              break;

            case 'FEED_STATE':
              usefulFeed.service = F.val;
              usefulFeed.service_updated = localize_date( F.history.modified.date );
              break;

            case 'XAU':
              usefulFeed.XAU_RAW = parseFloat( F.val );
              usefulFeed.XAU = get_euro_value( parseFloat( F.val ), change );
              usefulFeed.XAU_updated = localize_date( F.history.modified.date );
              break;

            case 'XAG':
              usefulFeed.XAG_RAW = parseFloat( F.val );
              usefulFeed.XAG = get_euro_value( parseFloat( F.val ), change );
              usefulFeed.XAG_updated = localize_date ( F.history.modified.date );
              break;

            default:
            case 'USD-EUR':
            case 'FIX_STATE':
              // do nothing by default.
              break;
          }
        });

        // store current feed on storage
        // usefulFeed.LOCAL_UPDATE = get_now_time();

        // set feed data
        FeedStruct( usefulFeed );
        resolve( usefulFeed );

      }).catch( err => {
        reject( err );
      });
    });
  }

  function localize_date ( date ) {

    let res = new Date( date );
    console.log( res );

    res.setHours( res.getHours() + 2 );

    // res = Intl.DateTimeFormat( date );

    return res.toLocaleString();

  }

  /* WORKING: store and check periodically time passed
   * for launching the new update.
   */
  function check_time ( lastUpdate ) {
    // override return
    return true;




    // let change = get_time_passed( lastUpdate );
    //
    // if ( change == null ) {
    //   console.log( 'change is not in milliseconds !! ', change );
    //   return false;
    // }
    //
    // // TODO, time passed will be dynamic,
    // // based on update settings, received form db.
    // if ( change >= ( delay * 60000 ) ) {
    //   return true;
    // } else {
    //   console.log( `current change ${change}` );
    //   return false;
    // }
  }


}
